import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_itinerary';
export const route = 'modify_itinerary/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_itinerary" */
/* webpackPrefetch: true */
'../components/ItineraryPage')));